import { CommonSelect, CustomAsyncSelect } from "components/Common/Common";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { FieldArray, useField, useFormikContext } from "formik";
import useModal from "hooks/useModal";
import React, { memo, useEffect, useRef, useState } from "react";
import { useLazyGetStartegyTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";
import threDots_img from "Assets/images/three-dots.png";
import { Accordion, Col, Dropdown, Row } from "react-bootstrap";
import AppInputField from "components/shared/FormComponents/AppInputField";
import SaveStrategyTemplatePop from "components/Modals/SaveStrategyTemplatePop";
import sliderImageRange from "../../../../Assets/images/sliderImagetoggle.png";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { components } from "react-select";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { STRATEGY_OPTIONS } from "config/constants";
import StrategiesTemplatesPop from "components/Modals/StrategyTemplatesPop";
import { isEmpty } from "lodash";
import { useGetDisciplineAreasQuery } from "store/services/utility";
import { useSelector } from "react-redux";

const QuestionMultipleObservation = ({ question, speechToText = false, sliderRefs, fieldData, previewMode, clientType, assessmentId, type = "Observation", showDate = true, max = 6, maxStrategy = 4, ...props }) => {
    const [field, meta] = useField(props.fieldName);
    const fieldName = "observations";
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const { setFieldValue, values, setFieldTouched, touched, errors } = useFormikContext();
    const [activeKey, setActiveKey] = useState(0);
    // save template modal

    const disciplineId = useSelector((state) => state?.auth?.user?.therapist_discipline?.id)

    const { data: disciplineAreas, isFetching: areasLoading } = useGetDisciplineAreasQuery(disciplineId, { skip: !disciplineId && clientType != 'school' });

    const disciplineAreaOptions =
        disciplineAreas?.length > 0
            ? disciplineAreas?.map(area => ({
                value: area.id,
                label: area.name
            }))
            : [];


    // useEffect(() => {
    //     if (!fieldData?.length) {
    //         return;
    //     }

    //     // Initialize form values if needed
    //     // fieldData.forEach((data, index) => {
    //     //     setFieldValue(`${fieldName}[${index}]`, {
    //     //         id: data?.id,
    //     //         answers: data?.answers,
    //     //         attachmentData: data?.attachmentData ? JSON.parse(data?.attachmentData) : [],
    //     //     })
    //     // })
    // }, [fieldData, fieldName]);

    const handleTemplateSelect = (index, selected) => {
        setSelectedTemplate(selected);
        setFieldValue(`${fieldName}[${index}].answers`, selected?.value?.answers || "")
    }

    const [getTemplates, { isFetching }] = useLazyGetStartegyTemplatesQuery();

    const getTemplateOptions = async (search) => {
        try {
            const data = await getTemplates({ assessmentId, search, clientType, status: "" }).unwrap();
            const templates = data?.records || [];
            return templates?.map(i => {
                return {
                    label: i.title,
                    value: i,
                    // tags: i.StrategyTemplateTagsMapping
                    //     ?.map(tag => tag?.strategyTemplateTags?.name)
                    //     .filter(Boolean) || []
                }
            })
        } catch (error) {
            console.log("Error Getting template options", error);
        };
    };

    useEffect(() => {
        sliderRefs.current = sliderRefs.current.slice(0, values[fieldName]?.length);
    }, [values[fieldName]?.length]);

    const SingleObservation = memo(({ index, observation, remove, push }) => {
        const [showDropdown, setShowDropdown] = useState(null);
        const dropdownRef = useRef(null);



        // Dropdown toggle handler
        const toggleDropdown = (e, index) => {
            e.stopPropagation();
            setShowDropdown(showDropdown === index ? null : index);
        };

        const handleDeleteObservation = async (e, index, remove) => {
            e.stopPropagation();
            const isConfirm = await confirmDialogV2({
                title: "DELETE OBSERVATION",
                message: "Are you sure you want to DELETE this from your consultation?",
            });
            if (!isConfirm) {
                return;
            }
            remove(index);
            setFieldTouched(fieldName, true);
        }

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setShowDropdown(null);
                }
            };

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, []);
        return (
            <>
                <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center' style={{ padding: "14px 0px 14px 18px" }}>
                    <div>
                        <div className='proxima-regular' style={{ fontWeight: 700, color: "#315D99" }}>
                            <span>{type} </span>{index + 1}
                        </div>
                    </div>
                    <div style={{ marginRight: "10px" }}>
                        <div ref={dropdownRef} className="cstm-dropdownclass">
                            <Dropdown show={showDropdown === index}>
                                <Dropdown.Toggle id="dropdown-basic">
                                    <img onClick={(e) => toggleDropdown(e, index)} width={19} height={18} src={threDots_img} alt="threDots_img" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={(e) => { handleDeleteObservation(e, index, remove) }}>Delete</Dropdown.Item>
                                    <Dropdown.Item disabled={values[fieldName]?.[index]?.show_tracker == 'show'} onClick={(e) => { e.stopPropagation(); setFieldValue(`${fieldName}.${index}.show_tracker`, "show") }}>Add Slider</Dropdown.Item>
                                    <Dropdown.Item disabled={values[fieldName]?.[index]?.show_tracker == 'hidden'} onClick={(e) => { e.stopPropagation(); setFieldValue(`${fieldName}.${index}.show_tracker`, "hidden") }}>Remove Slider</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </>
        )
    })

    return (
        <div>
            <FieldArray name={fieldName}>
                {({ push, remove }) => (
                    <>
                        <div className="goals goals-accordion" style={{ borderBottom: "0.75px solid #315D99", paddingBottom: "28px" }}>
                            <Accordion onClick={(e) => e.stopPropagation()} activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                                {values[fieldName]?.map((observation, index) => (
                                    <React.Fragment key={index}>
                                        <Accordion.Item className="border-0" eventKey={index}>

                                            <Accordion.Header style={{ borderBottom: "0.75px solid #000" }}>
                                                <SingleObservation
                                                    key={index}
                                                    observation={observation}
                                                    index={index}
                                                    remove={remove}
                                                    push={push}
                                                />

                                                {/* <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center' style={{ padding: "14px 0px 14px 18px" }}>
                                                <div>
                                                    <div className='proxima-regular' style={{ fontWeight: 700, color: "#315D99" }}>
                                                        <span>Observation </span>{index + 1}
                                                    </div>
                                                </div>
                                                <div style={{ marginRight: "10px" }}>
                                                    <div ref={dropdownRef} className="cstm-dropdownclass">
                                                        <Dropdown show={showDropdown === index}>
                                                            <Dropdown.Toggle id="dropdown-basic">
                                                                <img onClick={(e) => toggleDropdown(e, index)} width={19} height={18} src={threDots_img} alt="threDots_img" />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item onClick={(e) => { handleDeleteObservation(e, index, remove) }}>Delete</Dropdown.Item>
                                                                <Dropdown.Item disabled={values[fieldName]?.[index]?.show_tracker == 'show'} onClick={(e) => { e.stopPropagation(); setFieldValue(`${fieldName}.${index}.show_tracker`, "show") }}>Add Slider</Dropdown.Item>
                                                                <Dropdown.Item disabled={values[fieldName]?.[index]?.show_tracker == 'hidden'} onClick={(e) => { e.stopPropagation(); setFieldValue(`${fieldName}.${index}.show_tracker`, "hidden") }}>Remove Slider</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>



                                                    </div>
                                                </div>
                                            </div> */}
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="mb-4 slider-text-area">
                                                    <Col lg="4" className="px-0">
                                                        {
                                                            showDate && <div className="session-header-date" style={{ width: "60%" }}>
                                                                <label style={{ fontSize: '12px', fontFamily: 'Proxima Nova' }} className="discharge-screen-label proxima fw-bold text-dark">DATE OF OBSERVATION</label>
                                                                <AppDatePicker
                                                                    name={`${fieldName}.${index}.obs_date`}
                                                                    className="w-100 py-2"
                                                                // disabled={previewMode}
                                                                />
                                                            </div>
                                                        }
                                                        <p style={{ fontStyle: "italic", marginTop: "15px", color: "rgb(7, 30, 62)" }}>{question.placeholder}</p>

                                                        {
                                                           ["school", "private", "home_education", "home-education"]?.includes(clientType) &&
                                                            <div className=" w-100 align-items-center ">
                                                                <label style={{ fontSize: '12px', fontFamily: 'Proxima Nova' }} className="discharge-screen-label proxima fw-bold text-dark">AREA</label>

                                                                <CommonSelect
                                                                    placeholder={"Select"}
                                                                    option={disciplineAreaOptions || []}
                                                                    // onChange={(e) => handleFilterChange("status")(e)}
                                                                    name={`${fieldName}.${index}.area_id`}
                                                                    // value={filter?.status}
                                                                    isFilterV2
                                                                    // isClearable
                                                                    // isLoading={schoolListLoading || schoolListFetching}
                                                                    styles={{
                                                                        container: (provided) => ({
                                                                            ...provided,
                                                                            width: "100%", // ✅ Ensures the whole Select container is full width
                                                                        }),
                                                                    }}
                                                                />
                                                            </div>
                                                        }
                                                    </Col>
                                                    <Col lg="8" className="session-input-radio text-area-report">
                                                        <Row>
                                                            <Col lg="12">
                                                                {
                                                                    values[fieldName]?.[index]?.show_tracker == 'show' &&
                                                                    <div className="position-relative slider-range mt-5">
                                                                        <AppInputField
                                                                            id="frequency-range"
                                                                            style={{ height: "0px", position: "relative", zIndex: "1" }} className="w-100"
                                                                            // className="form-control rounded-3 bg-white is-resizable-textarea"
                                                                            name={`${fieldName}.${index}.tracker_percentage`}
                                                                            type={"range"}
                                                                            min="0"
                                                                            max="100"
                                                                        />
                                                                        <div className="d-flex mt-2 align-items-center justify-content-between">
                                                                            <p>Low</p>
                                                                            <p>High</p>
                                                                        </div>
                                                                        <img style={{ userSelect: "none" }} className="range-img" src={sliderImageRange} alt="sliderImageRange" />
                                                                    </div>
                                                                }</Col>
                                                        </Row>
                                                        <AppInputField
                                                            name={`${fieldName}.${index}.notes`}
                                                            placeholder={"Enter text..."}
                                                            fieldType={"textarea"}
                                                            rows={4}
                                                            speechToText={speechToText}
                                                            className="form-control rounded-3 bg-white is-resizable-textarea"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <FieldArray name={`${fieldName}.${index}.strategy`}>
                                                        {({ push: strategyPush, remove: strategyRemove }) => (
                                                            <>
                                                                {observation.strategy?.map((strategy, strategyIndex) => (
                                                                    <React.Fragment key={strategyIndex}>
                                                                        <Col lg="12">
                                                                            <div className="mb-4">
                                                                                <StrategyForm
                                                                                    speechToText={speechToText}
                                                                                    touched={touched}
                                                                                    errors={errors}
                                                                                    setFieldTouched={setFieldTouched}
                                                                                    question={question}
                                                                                    clientType={clientType}
                                                                                    strategyIndex={strategyIndex}
                                                                                    index={index}
                                                                                    setFieldValue={setFieldValue}
                                                                                    values={values}
                                                                                    outerFieldName={fieldName}
                                                                                    assessmentId={assessmentId}
                                                                                    fieldName={`${fieldName}.${index}.strategy`}
                                                                                    getTemplateOptions={getTemplateOptions}
                                                                                    // openModal={open}
                                                                                    // close={close}
                                                                                    remove={strategyRemove}
                                                                                    maxStrategy={maxStrategy}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </React.Fragment>
                                                                ))}
                                                                <Col lg="12">
                                                                    <div style={{ borderTop: "0.75px solid #315D99", paddingTop: "13px" }} className="d-flex mt-2 align-items-center gap-3">
                                                                        {
                                                                            (maxStrategy && maxStrategy > values[fieldName]?.[index]?.strategy?.length) &&
                                                                            < button
                                                                                className="blue-discharge-screen-btn mt-0"
                                                                                type="button"
                                                                                onClick={() => strategyPush({
                                                                                    answers: "",
                                                                                    attachmentData: [],
                                                                                })}
                                                                            >
                                                                                Add Strategy
                                                                            </button>
                                                                        }
                                                                        <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. 4 per observation. Use attachments to add more content.</p>
                                                                    </div>
                                                                    {
                                                                        touched.observations?.[index]?.strategy && errors.observations?.[index]?.strategy && typeof (errors.observations?.[index]?.strategy) == "string" ? (
                                                                            <div className="text-danger mt-3">{errors.observations?.[index]?.strategy}</div>
                                                                        ) : null
                                                                    }
                                                                </Col>
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </React.Fragment>
                                ))}
                            </Accordion >
                        </div>

                        <div style={{ position: "absolute", left: "-999999px", width: "500px", }} className="export-slider">
                            {values[fieldName]?.map((observation, index) => (
                                <Row>
                                    <Col ref={el => sliderRefs.current[index] = el} style={{ width: "100%" }} lg="12">
                                        {
                                            values[fieldName]?.[index]?.show_tracker == 'show' &&
                                            <div className="position-relative slider-range mt-5">
                                                <AppInputField
                                                    id="frequency-range"
                                                    style={{ height: "0px", position: "relative", zIndex: "1" }} className="w-100"
                                                    // className="form-control rounded-3 bg-white is-resizable-textarea"
                                                    name={`${fieldName}.${index}.tracker_percentage`}
                                                    type={"range"}
                                                    min="0"
                                                    max="100"
                                                />
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p>Low</p>
                                                    <p>High</p>
                                                </div>
                                                <img style={{ userSelect: "none" }} className="range-img" src={sliderImageRange} alt="sliderImageRange" />
                                            </div>
                                        }</Col>
                                </Row>
                            ))}
                        </div>

                        <div className="d-flex mt-2 align-items-center gap-3">
                            {
                                (max && max > values[fieldName]?.length) && <button
                                    type="button"
                                    className="blue-discharge-screen-btn mt-0"
                                    onClick={() => {
                                        push({
                                            tracker_percentage: 0,
                                            notes: "",
                                            strategy: [],
                                            show_tracker: "show"
                                        })
                                        setActiveKey(values[fieldName]?.length)
                                    }}
                                >
                                    Add{type == "Goal" ? " a Goal" : " an Observation"}
                                </button>
                            }
                            <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. 6 per plan.</p>
                        </div>
                    </>
                )}
            </FieldArray>
        </div >
    );
};

const StrategyForm = ({ index, strategyIndex, speechToText, setFieldValue, values, assessmentId, clientType, fieldName, outerFieldName, getTemplateOptions, remove, question, maxStrategy, touched, errors, setFieldTouched }) => {
    const { show, data, open, close } = useModal();
    const { show: showTemplates, data: templatesData, open: templatesOpen, close: templatesClose } = useModal();
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const handleTemplateSelect = (selected) => {
        setSelectedTemplate(selected);
        setFieldValue(`${fieldName}.${strategyIndex}.answers`, selected?.value?.answers || "");
        setFieldValue(`${fieldName}.${strategyIndex}.attachmentData`, values?.[fieldName]?.[strategyIndex]?.attachmentData || []);
    }

    const handleDeleteStrategy = async (e, stratIndex, remove) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "DELETE STRATEGY",
            message: "Are you sure you want to DELETE this from your consultation?",
        });
        if (!isConfirm) {
            return;
        }
        remove(stratIndex);
        setFieldTouched(fieldName, true)
    }

    useEffect(() => {
        if (values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.template_id) {
            setSelectedTemplate({ value: values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.template_id, label: values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.title })
        }
    }, [data])

    const Option = (props) => {
        const { data, isSelected } = props;
        return (
            <components.Option {...props}>
                <div>
                    <div
                        style={{
                            // fontWeight: isSelected ? "bold" : "normal",
                            color: isSelected
                                ? "#fff"
                                : "#212529"
                        }}
                    >
                        {data.label}
                    </div>
                    {data.tags?.length > 0 && (
                        <div className="mt-1 d-flex flex-wrap gap-1">
                            {data.tags.map((tag, idx) => (
                                <div
                                    key={idx}
                                    className="rounded-pill"
                                    style={{
                                        pointerEvents: "none",
                                        fontWeight: "normal",
                                        backgroundColor: "#e8f5fe",
                                        color: "#007bff",
                                        border: "1px solid #007bff",
                                        padding: "1px 5px",
                                        fontSize: "12px"
                                    }}
                                >
                                    {tag}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </components.Option>
        );
    };
    // console.log('fieldName', values?.fieldName])

    return (
        <>
            <SaveStrategyTemplatePop
                mainSetFieldValue={setFieldValue}
                outerFieldName={outerFieldName}
                index={index}
                strategyIndex={strategyIndex}
                showPopup={show}
                closePopup={close}
                data={data}
                clientType={clientType}
                assessmentId={assessmentId}
            />
            <StrategiesTemplatesPop
                mainSetFieldValue={setFieldValue}
                setSelectedTemplate={setSelectedTemplate}
                outerFieldName={outerFieldName}
                index={index}
                strategyIndex={strategyIndex}
                showPopup={showTemplates}
                closePopup={templatesClose}
                data={data}
                clientType={clientType}
                assessmentId={assessmentId}
            />
            <Row>
                <Col style={{ borderBottom: "0.75px solid #000" }} className="px-0" lg="12">
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 class="m-0 proxima themeBlue fw-bold text-uppercase" style={{ fontSize: "12px" }}>STRATEGY {strategyIndex + 1}</h6>
                        <div className="cstm-dropdownclass">
                            <Dropdown>
                                <Dropdown.Toggle id="dropdown-basic">
                                    <img width={19} height={18} src={threDots_img} alt="threDots_img" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={(e) => handleDeleteStrategy(e, strategyIndex, remove)}>Delete</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </Col>
                <Col lg="4" className="px-0" style={{ margin: "12px 0" }}>
                    <p style={{ fontStyle: "italic", color: "#071E3E" }}>{question.template}</p>
                </Col>
                <Col lg="8" style={{ margin: "12px 0" }}>
                    {
                        values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.answers || values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.strategyRadio == "newStrategy" ?
                            <>
                                {
                                    values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.template_id &&
                                    <div className=" justify-content-between gap-3 align-items-center" style={{ borderBottom: "0.75px solid #000000", padding: "0px 0" }}>
                                        <h6 class=" proxima themeBlue" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "10px" }}>Strategy Template</h6>
                                        <div className="w-100">
                                            <CustomAsyncSelect
                                                cstmOption={Option}
                                                placeholder={"(no template selected)"}
                                                loadOptions={getTemplateOptions}
                                                onChange={handleTemplateSelect}
                                                value={selectedTemplate}
                                                defaultOptions={true}
                                            />
                                        </div>
                                        {/* <p>{values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.title}</p> */}

                                    </div>
                                }
                                <div className="ck-editor-wrapper my-2">
                                    <CustomEditor
                                        speechToText={speechToText}
                                        name={`${fieldName}.${strategyIndex}.answers`}
                                        attachmentName={`${fieldName}.${strategyIndex}.attachmentData`}
                                    />
                                </div>
                                {
                                    !values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.template_id &&
                                    <button
                                        className="blue-discharge-screen-btn mt-0"
                                        type="button"
                                        onClick={() => {
                                            open({
                                                // name: values[fieldName][strategyIndex]?.name,
                                                answers: values?.observations?.[index]?.strategy[strategyIndex]?.answers,
                                            });
                                        }}
                                    >
                                        Save to Templates
                                    </button>
                                }
                            </>

                            :
                            <div className="session-input-radio text-area-report">

                                <div className="radio-inputs">
                                    <AppRadioField
                                        containerClass={"d-flex align-items-center py-1"}
                                        options={STRATEGY_OPTIONS}
                                        name={`${outerFieldName}.${index}.strategy.${strategyIndex}.strategyRadio`}
                                        labelStyles={{
                                            color: "#071E3E",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            fontFamily: "Proxima Nova regular",
                                        }}
                                    />
                                    < button
                                        className="blue-discharge-screen-btn mt-3"
                                        type="button"
                                        disabled={!values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.strategyRadio}
                                        onClick={() => {
                                            if (values?.[outerFieldName]?.[index]?.strategy?.[strategyIndex]?.strategyRadio == "new") {
                                                // open({
                                                //     // name: values[fieldName][strategyIndex]?.name,
                                                //     answers: values?.observations?.[index]?.strategy[strategyIndex]?.answers,
                                                // });
                                                setFieldValue(`${outerFieldName}.${index}.strategy.${strategyIndex}.strategyRadio`, "newStrategy")
                                            }
                                            else {
                                                // alert("REACHED", fieldName)
                                                templatesOpen();
                                            }
                                        }}
                                    // onClick={() => strategyPush({
                                    //     answers: "",
                                    //     attachmentData: [],
                                    // })}
                                    >
                                        Continue
                                    </button>
                                    {
                                        touched.observations?.[index]?.strategy && !isEmpty(errors.observations?.[index]?.strategy) ? (
                                            <div className="text-danger mt-3">{"Please add strategy data"}</div>
                                        ) : null
                                    }
                                </div>
                            </div>
                    }
                </Col>

            </Row>
        </>
    )
}

export default QuestionMultipleObservation;

